import React, { useState } from "react";
import { useFormik } from 'formik'
import * as Yup from 'yup';
import AppBar from "../components/app_bar/AppBar";
import Drawer from "../components/Drawer";
import { 
    Typography, Step, CssBaseline, Box, Toolbar, Grid2, Stepper, StepLabel, Button, FormHelperText, useMediaQuery,
} from '@mui/material';

import FillInForm from "../components/organization_update_request/FillInForm";
import ConfirmationForm from "../components/organization_update_request/ConfirmationForm";
import ReviewForm from "../components/organization_update_request/ReviewForm";
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from '@mui/material/styles';

import NotFound from './NotFound';

import * as CONSTANTS from "../constants"


const OrganizationUpdateRequest = () => {

    document.title = `Request Update Organization - Wotagei Zone`

    const [username, ] = useState(localStorage.getItem('username') || localStorage.getItem('username'));

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection

    let {lang} = useParams();

    const [drawerOpen, setDrawerOpen] = useState(false);
            
    const handleDrawerOpen = (open) => {
        if (open === undefined) {
            setDrawerOpen(!drawerOpen)
        } else {
            setDrawerOpen(open);
        }
    }

    const navigate = useNavigate();
    const naivgateToRequestTopic = () => {
        navigate(`/${lang}/request-topic/`);
    }

    const [activeStep, setActiveStep] = useState(0);

    const handleBack = () => {
        setActiveStep((prevStep) => prevStep - 1);
    };

    // Step titles
    const steps = [
        CONSTANTS.REQUEST_TOPIC.STEPS.FILL_IN[lang], 
        CONSTANTS.REQUEST_TOPIC.STEPS.REVIEW[lang], 
        CONSTANTS.REQUEST_TOPIC.STEPS.CONFIRMATION[lang], 
    ];

    const formik = useFormik({
        initialValues: {
            name_en: '',
            name_jp: '',
            name_tc: '',
            name_sc: '',
            default_name: '',
            default_language: 'jp',
            region: '',
            markings: [],
            official_account_youtube: '',
            official_account_bilibili: '',
            official_account_x: '',
            key_members_uids: [],
            key_members_names: [],
            team_leader_uid: 0,
            team_leader_name: '',
            organization_uid: 0,
        },
        validationSchema: Yup.object().shape({
            name_en: Yup.string(),
            name_jp: Yup.string(),
            name_tc: Yup.string(),
            name_sc: Yup.string(),
            default_name: Yup.string(),
            default_language: Yup.string(),
            region: Yup.string(), 
            markings: Yup.array().of(Yup.string()),
            official_account_youtube: Yup.string(),
            official_account_bilibili: Yup.string(),
            official_account_x: Yup.string(),
            key_members_uids: Yup.array().of(Yup.number()), 
            key_members_names: Yup.array().of(Yup.string()),
            team_leader_uid: Yup.number(),
            team_leader_name: Yup.string(),
            organization_uid: Yup.number(),
        }),
        onSubmit: (values) => {
            if(!values.name_en && !values.name_jp && !values.name_sc && !values.name_tc) {
                formik.setFieldError('name_en', CONSTANTS.REQUEST_TOPIC.ERROR_MESSAGE.REQUIRED_NAME.EN[lang])
                formik.setFieldError('name_jp', CONSTANTS.REQUEST_TOPIC.ERROR_MESSAGE.REQUIRED_NAME.JP[lang])
                formik.setFieldError('name_tc', CONSTANTS.REQUEST_TOPIC.ERROR_MESSAGE.REQUIRED_NAME.TC[lang])
                formik.setFieldError('name_sc', CONSTANTS.REQUEST_TOPIC.ERROR_MESSAGE.REQUIRED_NAME.SC[lang])
                return
            }
            if(!values.default_name) {
                switch (values.default_language) {
                    case 'en':
                    case 'jp':
                    case 'tc':
                    case 'sc':
                        formik.setFieldError('name_'+values.default_language, CONSTANTS.REQUEST_TOPIC.ERROR_MESSAGE.NON_EMPTY_DEFAULT_NAME[lang]);
                        return;
                    default:
                        return;
                }
            }
            if (activeStep === steps.length - 1) {
                // last step
            } else {
                setActiveStep((prevStep) => prevStep + 1);
                // next step
            }
        },
    });

    const formContent = (step) => {
        if (username) {
            switch(step) {
                case 0:
                    return <FillInForm formik={formik} lang={lang}/>;
                case 1:
                    return <ReviewForm formik={formik} lang={lang}/>;
                case 2:
                    return <ConfirmationForm formik={formik} lang={lang}/>;
                default:
                    return <NotFound />
            }
        } else {
            return <NotFound />
        }
    };

    return (
        <Box >
            <CssBaseline />
            <AppBar lang={lang} handleDrawerOpen={handleDrawerOpen}/>
            <Box sx={{ display: 'flex' }}>
                <Drawer lang={lang} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
                <Box component="main" sx={{ flexGrow: 1, p: isMobile? 2: 3 }}>
                    <Toolbar />
                    <Grid2
                        container
                        spacing={2}
                        direction="column"
                        alignItems="center"
                        justifyContent="center"       
                    >
                        <Grid2 
                            item 
                            xs={12}
                            md={12}
                            sx={{width: '100%'}}
                        >
                            <Box sx={{ my: 5 }}>
                                <Typography 
                                    variant="h4" 
                                    style={{
                                        textAlign: "center",
                                        marginLeft: '1.5rem',
                                        fontWeight: "bolder",
                                    }}
                                >
                                    {CONSTANTS.DRAWER.REQUEST_TOPIC[lang]+" - "+CONSTANTS.REQUEST_TOPIC.HOME.UPDATE_ORGANIZATION[lang]}
                                </Typography>
                            </Box>
                            <Stepper size="lg" sx={{ py: isMobile? 2: 3}} activeStep={activeStep} alternativeLabel>
                                {steps.map((label, index) => (
                                    <Step key={index}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Grid2>
                        <Grid2 item xs={12} md={12}>
                            {formContent(activeStep)}
                            {
                                formik.errors.submit 
                                && 
                                (
                                    <Grid2
                                        item
                                        xs={12} md={12}
                                    >
                                        <FormHelperText error>
                                        {formik.errors.submit}
                                        </FormHelperText>
                                    </Grid2>
                                )
                            }
                        </Grid2>
                        <Grid2 item xs={12} md={12} mt={3}>
                            <Box sx={{ textAlign: "center", }}>
                                {activeStep === steps.length - 1 ? (
                                    <Button onClick={naivgateToRequestTopic}>
                                        {CONSTANTS.REQUEST_TOPIC.BUTTONS.END[lang]}
                                    </Button>
                                ) : (
                                    <>
                                        <Button
                                            disabled={activeStep !== 1}
                                            onClick={handleBack}
                                        >
                                            {CONSTANTS.REQUEST_TOPIC.BUTTONS.BACK[lang]}
                                        </Button>
                                        <Button onClick={formik.handleSubmit}>
                                            {CONSTANTS.REQUEST_TOPIC.BUTTONS.NEXT[lang]}
                                        </Button>
                                    </>
                                ) }
                            </Box>
                        </Grid2>
                        
                    </Grid2>
                </Box>
            </Box>
        </Box>
    );
};
 
export default OrganizationUpdateRequest;